// extracted by mini-css-extract-plugin
export default {"wrapper":"stylesForPic_wrapper__2hQKl","italic":"stylesForPic_italic__fmqO3","images":"stylesForPic_images__ZcRYE","imageItem":"stylesForPic_imageItem__QxR8T"};